import { createContext, useCallback, useContext, useState } from "react";

const BookDemoContext = createContext({
    isOpen: false,
    mode: "demo",
    prefillMessage: "",
    prefillSelection: null,
    open: () => {},
    close: () => {},
});

export function BookDemoProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const [mode, setMode] = useState("demo");
    const [prefillMessage, setPrefillMessage] = useState("");
    const [prefillSelection, setPrefillSelection] = useState(null);

    const open = useCallback((opts = {}) => {
        setMode(opts.mode || "demo");
        setPrefillMessage(opts.message || "");
        setPrefillSelection(opts.selection || null);
        setIsOpen(true);
    }, []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <BookDemoContext.Provider value={{ isOpen, mode, prefillMessage, prefillSelection, open, close }}>
            {children}
        </BookDemoContext.Provider>
    );
}

export function useBookDemo() {
    return useContext(BookDemoContext);
}
